import React, {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import axios from 'axios';
import conf from '../../conf'
import {Switch} from '@mui/material'
import { Add } from '@material-ui/icons'
import {useToasts} from 'react-toast-notifications'
import DropdownMenu from '../dropdown_menu/DropdownMenu';

const AlertActionPopup = ()=>{

     const {addToast} = useToasts();
     const go = useNavigate();

     const defultValue = {
        enabled: false,
        message: '',
        action: 'NONE',
        actionText: 'Got It',
        data: {},
     };

     const [lotterys, setLotterys] = useState([]);
     const [chooseMode, setChooseMode] = useState("NONE");
     const [isSending, setIsSending] = useState(false);
     const [formData, setFormData] = useState(null);

     const selectionItemKeys = ["NONE", "LINK", "LOTTERY_SCREEN", "WINNER_SCREEN", "PROFILE_SCREEN", "EDIT_PROFILE_SCREEN", "ADD_MONEY_SCREEN", "RESULT_SCREEN"];

     const getSetting = async ()=>{
          try {
               const res = await axios.get(conf.serverAddress + "admin/popup-action-alert", {
                    headers: {"Authorization" : `Bearer ${document.cookie.split("=")[1]}`}
               });
               setFormData(res.data)
          } catch (err) {
               console.log(err);
          }
     }

     const getLotterys = async ()=>{
          try {
               const res = await axios.get(conf.serverAddress + "admin/lotterys", {
                    headers: {"Authorization" : `Bearer ${document.cookie.split("=")[1]}`}
               });
               setLotterys(res.data);
               return res.data;
          } catch (err) {
               console.log(err);
               return null;
          }
     }

     useEffect(()=>{ getSetting(); getLotterys();}, [])

     const onSubmit = async ()=>{

          setIsSending(true);
          try {
               const rBody = new FormData();
               rBody.append('enabled', formData.enabled);
               rBody.append('message', formData.message);
               rBody.append('action', formData.action);
               rBody.append('actionText', formData.actionText);
               rBody.append('data', JSON.stringify(formData.data));
               
               const res = await axios({
                    method: "PATCH", 
                    data: rBody,
                    url: conf.serverAddress + "admin/popup-action-alert",
                    headers: { 
                         "Content-Type": "multipart/form-data",
                         "Authorization" : `Bearer ${document.cookie.split("=")[1]}`
                    }
               });
               setIsSending(false)
               addToast("Changes saved successfully", {
                    appearance: 'success',
                    autoDismiss: true,
               })
          } catch (error) {
               console.log(error);
               setIsSending(false)
               setFormData(defultValue)
               addToast("Failed", {
                    appearance: 'error',
                    autoDismiss: true,
               })
          }
     } 

     const onLotteryChoose = async ()=> {
          if(lotterys.length == 0){
               await getLotterys();
          }
          if(lotterys.length != 0){
               setChooseMode("LOTTERY");
          }
          else {
               addToast("Not found. Please add new lottery", {
                    appearance: 'error',
                    autoDismiss: true,
               })
          }
     }

     const vBox = {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
     };

     const sInput = {width: "440px", marginTop: "10px", border: '1px solid #8a8a8a', borderRadius: "5px", padding: '10px 15px'};

     if(!formData) return null;

     if(chooseMode == "LOTTERY"){
          return( 
               <div style={{display: 'flex', justifyContent: "center"}}>
                    <div className="card" style={{width: '500px', padding: "20px 25px"}}>
                         <h3>Choose Lottery</h3>
                         {
                              lotterys.map((val)=> 
                                   <div style={{background: '#f0f0f0', borderRadius: '5px', marginBottom: '10px', padding: '10px 10px'}}>
                                        <div style={{display: 'flex', justifyContent: "space-between", marginBottom: '5px'}}>
                                             <span style={{fontSize: "18px", fontWeight: 'bold'}}>{val.type} {val.time}</span>
                                             <span style={{color: "blue", cursor: 'pointer'}} onClick={()=> {setFormData({...formData, data: val}); setChooseMode("NONE")}}>Choose</span>
                                        </div>
                                        <span>{val.series} Series - {val.endDate} - ₹{val.prices} - {val.open ? "Open" : "Closed"}</span>
                                   </div>
                              )
                         }
                    </div>
               </div>
          );
     }

     return(
          <div style={{display: 'flex', justifyContent: "center"}}>
               <div className="card" style={{width: '500px', padding: "20px 25px"}}>
                    <h3>Alert Popup</h3>
                    <div style={vBox}>
                         Enabled <Switch checked={formData.enabled} onChange={(e, is)=>setFormData({
                                   ...formData,
                                   enabled: is
                              })} />
                    </div>
                    <div style={{marginTop: '15px'}}>
                         Message <br />
                         <textarea style={{...sInput, height: '100px'}}  onChange={e=> setFormData({
                                    ...formData,
                                    message: e.target.value
                                })}
                            placeholder="text..." 
                            maxLength={100}
                            value={formData.message}/>
                    </div>
                    <div style={vBox}>
                         <span style={{marginBottom: "-15px"}}>Action</span> 
                         <DropdownMenu items={selectionItemKeys} defaultValue={formData.action} textStyle={{width: "auto"}} style={{background: "#f0f0f0"}} onChange={async (value, i)=> {
                              setFormData({
                                   ...formData,
                                   action: selectionItemKeys[i],
                                   data: {url: ""},
                              });
                         }}/>
                    </div>

                    {  formData.action != "NONE"  ?
                         <div style={{marginTop: '15px'}}>
                              Action Text <br />
                              <input value={formData.actionText} type="text" style={{...sInput}} maxLength={12} onChange={e=> setFormData({
                                   ...formData,
                                   actionText: e.target.value
                              })} placeholder="text..." />
                         </div> : null
                    }

                    {  formData.action == "LINK" || formData.action == "RESULT_SCREEN"  ?
                         <div style={{marginTop: '15px'}}>
                              URL <br />
                              <input value={formData.data.url} type="url" style={{...sInput}} onChange={e=> setFormData({
                                   ...formData,
                                   data: {url: e.target.value},
                              })} placeholder="url..." />
                         </div> : null
                    }

                    {  formData.action == "LOTTERY_SCREEN"  ?
                         <div style={{marginTop: '15px'}}>
                              Choose Lottery <br />
                              <button onClick={onLotteryChoose} className="badge badge-gradient-success"  style={{
                                   width: '200px', display: 'flex', justifyContent: 'center',
                                   border: 'none', borderRadius: '5px', fontSize: '16px',
                                   padding: '10px 0', cursor: isSending ? 'wait' : 'pointer' ,
                                   marginTop: '20px'
                              }}> <Add/> <span style={{marginTop: "5px", marginLeft: "10px"}}>{formData.data._id ? "Change" : "Choose"}</span></button>
                              { formData.data._id ? <div style={{background: '#f0f0f0', borderRadius: '5px', marginBottom: '10px', padding: '10px 10px', marginTop: '10px'}}>
                                        <div style={{display: 'flex', justifyContent: "space-between", marginBottom: '5px'}}>
                                             <span style={{fontSize: "18px", fontWeight: 'bold'}}>{formData.data.type} {formData.data.time}</span>
                                        </div>
                                        <span>{formData.data.series} Series - {formData.data.endDate} - ₹{formData.data.prices} - {formData.data.open ? "Open" : "Closed"}</span>
                              </div> : null}
                         </div> : null
                    }
                    
                    <button onClick={onSubmit} className="badge badge-gradient-success"  style={{
                         width: '440px', display: 'flex', justifyContent: 'center',
                         border: 'none', borderRadius: '5px', fontSize: '16px',
                         padding: '10px 0', cursor: isSending ? 'wait' : 'pointer' ,
                         marginTop: '20px'
                    }}>Save</button>
               </div>
          </div>
     );
}
export default AlertActionPopup;